import { useMutation } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";
import type { components } from "../schema";

export type TradeWhatIfBody = components["schemas"]["TradeWhatIfBody"];
export type TradeWhatIfResponse = components["schemas"]["TradeWhatIfResponse"];
export type FillModificationBody =
  components["schemas"]["FillModificationBody"];
export type FillModificationKind =
  components["schemas"]["FillModificationKind"];
export type WhatIfKpisResponse = components["schemas"]["WhatIfKpisResponse"];

export function useSimulateTradeWhatIf(tradeId: string) {
  const client = useApiClient();
  return useMutation<TradeWhatIfResponse, Error, TradeWhatIfBody>({
    mutationFn: async (body) => {
      const { data, error } = await client.POST(
        "/api/trades/{trade_id}/whatif",
        {
          params: { path: { trade_id: tradeId } },
          body,
        },
      );
      if (error !== undefined) {
        throw new Error("Failed to run What If simulation");
      }
      return data;
    },
  });
}
